import React from 'react';
import VoiceOverArtistsV2Component from '../components/VoiceOverArtistsV2';
import { AuthorisationConsumer } from '../../../../../AuthorisationWrapper';
import { UploaderConsumer } from '../../../../../Uploader';
import RequestProvider from '../../../../../RequestProvider';
import { getAssetsApi } from '../../../../api';
import { updateVideoAtomicQuery } from '../../../../../AssetLibrary/queries';
import { AddonsContextConsumer } from '../../../../context/AddonsContext';






















export default function VoiceOverArtistsV2(props) {
  return (
    <RequestProvider
      requests={{
        getAssets: getAssetsApi(),
        updateVideoAtomic: updateVideoAtomicQuery()
      }}>

      {({ getAssets, updateVideoAtomic }) =>
      <AuthorisationConsumer>
          {({ selectedOrganisation: { organisationId, customAddonCosts } }) =>
        <UploaderConsumer>
              {({ addFileToQueue, assetsMap }) =>
          <AddonsContextConsumer>
                  {({
              actions: { getBillingEntityCode }
            }) =>
            <VoiceOverArtistsV2Component
              customAddonCosts={customAddonCosts}
              getBillingEntityCode={getBillingEntityCode}
              addFilesToQueue={addFileToQueue}
              organisationId={organisationId}
              getAssets={getAssets}
              assetsMap={assetsMap}
              updateVideoAtomic={updateVideoAtomic}
              {...props} />}


                </AddonsContextConsumer>}

            </UploaderConsumer>}

        </AuthorisationConsumer>}

    </RequestProvider>);

}